import IconBtn from './IconBtn';
import './styles/dialog.css';
import { motion, AnimatePresence } from 'framer-motion';
import { Capacitor } from '@capacitor/core';
import { createPortal } from 'react-dom';
import classNames from 'classnames';

type MiniDialogProps = {
  title?: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

function MiniDialog({ title, open, onClose, children }: MiniDialogProps) {
  const isNative = Capacitor.isNativePlatform();
  const dialogRoot =
    typeof window !== 'undefined' ? document.getElementById('dialog-root') || document.body : null;

  const containerClass = classNames('dialog-container', 'dialog-mini', {
    'dialog-safe-area': isNative,
  });

  if (!dialogRoot) return null;

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="dialog-backdrop !z-70 !bg-black/10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          style={{ willChange: 'opacity', transform: 'translateZ(0)' }}
        >
          <motion.div
            className={containerClass}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={(e) => e.stopPropagation()}
            style={{ willChange: 'opacity, transform', transform: 'translateZ(0)' }}
          >
            <div className="dialog-header-row">
              {title && <h2 className="dialog-title">{title}</h2>}
              <span className="dialog-close-btn">
                <IconBtn icon="X" noBackground largeStrokeSize xl onClick={onClose} />
              </span>
            </div>
            <div className="dialog-content">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    dialogRoot
  );
}

export default MiniDialog;
